// KL-23
export enum EventPriority {
	Small = 1,
	Medium = 2,
	High = 3,
	Critical = 4,
}
